<div
  class="bg-base-700 relative flex h-[50px] w-[50px] items-center justify-center rounded-[25px]"
>
  <svg
    class="fill-base-500 h-[21px] w-[21px]"
    [sharedUiSvgIcon]="iconPath()"
    [ngClass]="{ '-ml-[4px] h-[29px] w-[26px]': iconPath() === 'mesh-0' }"
  >
    <use [attr.xlink:href]="'#' + iconPath()"></use>
  </svg>
</div>
